module.exports = __webpack_public_path__ + "img/qr-lndr-bot.9dd1dc23.svg";